import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "../../WithTranslation";

export const AutocompleteDemandAnalysisEmptyState = () => {
    const t = useTranslation();

    return (
        <Flex
            alignItems="center"
            justifyContent="center"
            minHeight="60px"
            gap="8px"
        >
            <SWReactIcons
                iconName="no-search-results"
                size="sm"
            />
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[300]}
            >
                {t("demand.analysis.autocomplete.emptyState.lists")}
            </Text>
        </Flex>
    );
};
